import { render, staticRenderFns } from "./MyinfoSns.vue?vue&type=template&id=3fea7d88&scoped=true"
import script from "./MyinfoSns.vue?vue&type=script&lang=js"
export * from "./MyinfoSns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea7d88",
  null
  
)

export default component.exports